var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfilePortfolio.jinja');
require('./MemberProfilePortfolio.less');

var Inner = require('front/components/MemberProfile/MemberProfilePortfolioInner');
var Runtime = require('front/components/MemberProfile/MemberProfilePortfolioInnerRuntime.jinja');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateBlock');

        window.app.vent.on('MemberProfile--updatePortfolio', this.updateBlock);

        this.Inner = new Inner({
            el: this.$('.MemberProfilePortfolioInner')[0]
        });

        this.Inner.activate();

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('MemberProfile--updatePortfolio', this.updateBlock);

        this.Inner.deactivate();
        delete this.Inner;

        return Base.prototype.deactivate.call(this, params);
    },


    updateBlock: function (memberId) {
        this.Inner.deactivate();
        delete this.Inner;

        var data = window.app.data.members[memberId];

        var $template = $(Runtime.render({
            data: window.app.data.members[memberId],
            isOwner: window.app.settings.member == memberId
        }));

        this.$el.data('items', window.app.data.members[memberId].portfolio);

        this.$('.MemberProfilePortfolio-wrapper').html($template);

        this.Inner = new Inner({
            el: this.$('.MemberProfilePortfolioInner')[0]
        });

        this.Inner.activate();
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfilePortfolio.js
// module id = 200
// module chunks = 0